import { TaxTypeType } from './types.ts'

interface TaxTypeProps {
  tax_type: TaxTypeType
}

export default function TaxType({ tax_type }: TaxTypeProps) {
  return (
    <div>
      <p className="my-5">
        <strong className="block font-medium mb-1">Nom :</strong>
        {tax_type.name?.toString()}
      </p>
      <p className="my-5">
        <strong className="block font-medium mb-1">Code:</strong>
        {tax_type.code?.toString()}
      </p>
      <p className="my-5">
        <strong className="block font-medium mb-1">Description :</strong>
        {tax_type.description?.toString()}
      </p>
      <p className="my-5">
        <strong className="block font-medium mb-1">Actif :</strong>
        {tax_type.active?.toString()}
      </p>
      <p className="my-5">
        <strong className="block font-medium mb-1">Communauté :</strong>
        {tax_type.community_id?.toString()}
      </p>
    </div>
  )
}
